// The phone's wide lens ("0.5×"), for when the car won't fit and there's no
// room to step back (a car parked on a narrow street). Two ways a browser
// offers it:
//   zoom    the camera zooms out below 1× (some Android phones)
//   device  a separate back camera, by name (iPhones list "Back Ultra Wide
//           Camera" next to "Back Camera")
// Pure; unit-tested.

export type WideLens = { kind: "zoom"; zoom: number } | { kind: "device"; deviceId: string }

export interface CameraDevice {
  deviceId: string
  label: string
  kind: string
}

// The ultra-wide's name in the languages a US shop's customers are likely
// to have their phone in.
const ULTRA_WIDE = /ultra[\s-]*wide|ultra[\s-]*gran|ultraweit|ultra[\s-]*ampi|ultra[\s-]*amplo|超広角|超广角|초광각/i
const FRONT = /front|user|face|selfie|avant|frontal|vorder/i

export function findWideLens(devices: readonly CameraDevice[], zoom?: { min?: number } | null): WideLens | null {
  if (zoom?.min && zoom.min > 0 && zoom.min < 0.95) return { kind: "zoom", zoom: Math.max(0.5, zoom.min) }
  const wide = devices.find((d) => d.kind === "videoinput" && ULTRA_WIDE.test(d.label) && !FRONT.test(d.label))
  return wide?.deviceId ? { kind: "device", deviceId: wide.deviceId } : null
}
